import LeadsmaniaCollapsedLogo from 'src/icons/LeadsmaniaCollapsedLogo';
import { NavLink } from 'react-router-dom';

import useOnboardingLogoTarget from 'src/hooks/useOnboardingLogoTarget';

import useStyles from './Logo.styles';

export default function Logo({ ...props }) {
    const classes = useStyles();
    const logoTarget = useOnboardingLogoTarget();

    return (
        <NavLink
            to={logoTarget}
            className={classes.link}
            {...props}
        >
            <LeadsmaniaCollapsedLogo width={30} height={30} aria-hidden="true" />
            <span className={classes.wordmark}>ЛИДСМАНИЯ</span>
        </NavLink>
    );
}
